import { Button } from 'packages/smart-home-support/components';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import React from 'react';
import styled from 'styled-components';
import { useUser } from '../../../../../hooks';
import imageUrl from './assets/tch_hero.jpg';

const breakpoint = BREAK_POINTS.tablet;

const ButtonIcon: React.FC<{ className?: string }> = (props) => (
  <svg
    className={props.className}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5019 12.0001C15.8114 12.0001 18.5028 9.30759 18.5028 6.00006C18.5028 2.69253 15.8114 0 12.5019 0C9.19238 0 6.50098 2.69253 6.50098 6.00006C6.50098 9.30759 9.19238 12.0001 12.5019 12.0001Z"
      fill="black"
    />
    <path
      d="M12.5018 13.5C5.43573 13.5 0.5 17.2005 0.5 22.5001V24.0001H24.5036V22.5001C24.5036 17.2005 19.5678 13.5 12.5018 13.5Z"
      fill="black"
    />
  </svg>
);

const s = {
  Container: styled.div`
    @media ${breakpoint} {
      height: 730px;
      display: flex;
      flex-direction: row-reverse;
    }
  `,
  ContentSection: styled.div`
    background: #000;
    padding: 0 38px;
    padding-top: 25px;
    padding-bottom: 50px;
    box-sizing: border-box;
    @media ${breakpoint} {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 50%;
      padding-right: 60px;
      padding-left: 10%;
    }
  `,
  ImageSection: styled.div`
    height: 212px;
    background: url('${imageUrl}');
    background-position: center 39%;
    background-size: cover;
    background-repeat: no-repeat;
    @media ${breakpoint} {
      width: 50%;
      height: 100%;
      background-position: center center;
    }
  `,
  Heading: styled.h2`
    font-size: 32px;
    line-height: 1;
    color: #fff;
    margin-top: 0;
    margin-bottom: 16px;
    @media ${breakpoint} {
      font-size: 36px;
      margin-bottom: 25px;
    }
    @media ${BREAK_POINTS.tabletBig} {
      font-size: 42px;
    }
    @media ${BREAK_POINTS.desktop} {
      font-size: 50px;
    }
    @media ${BREAK_POINTS.desktopBig} {
      font-size: 60px;
    }
  `,
  Content: styled.div`
    color: #fff;
    font-size: 20px;
    line-height: 1.5;
    margin-bottom: 20px;
    @media ${breakpoint} {
      margin-bottom: 50px;
      padding-right: 20px;
    }
    @media ${BREAK_POINTS.tabletBig} {
      font-size: 24px;
    }
  `,
  Button: styled(Button)`
    font-weight: bold;
    font-size: 16px;
    @media ${BREAK_POINTS.mobileBig} {
      font-size: 18px;
    }
    @media ${breakpoint} {
      font-size: 16px;
    }
    @media ${BREAK_POINTS.tabletBig} {
      font-size: 18px;
    }
  `,
  ButtonIcon: styled(ButtonIcon)`
    vertical-align: middle;
    margin-right: 15px;
    display: none;
    @media ${BREAK_POINTS.mobileBig} {
      display: initial;
    }
    @media ${breakpoint} {
      display: none;
    }
    @media ${BREAK_POINTS.tabletBig} {
      display: initial;
    }
  `,
};

const TCHHero = () => {
  const user = useUser();

  return (
    <s.Container>
      <s.ImageSection />
      <s.ContentSection>
        <s.Heading>We&rsquo;ve got you covered.</s.Heading>
        <s.Content>
          Verizon Protect Home is your one-stop-shop for home tech. The plan includes protection and 24/7 Tech Coach
          support&mdash;so you can focus on the things that matter.
        </s.Content>
        <s.Button inverted to="/dashboard">
          <s.ButtonIcon />
          {user ? 'Access your dashboard' : 'Log in or create account'}
        </s.Button>
      </s.ContentSection>
    </s.Container>
  );
};

export default TCHHero;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/Hero/TCHHero/TCHHero.tsx